export default "__VITE_ASSET__CVuyTH8G__"